module.exports = __webpack_public_path__ + "res/ic_logout_rtl.456125fd1194946377f96239952fe348.png";